<template>
<DialogBox title="Task Details" :settings="settings" @save="saveDocument" @show="initialise">
<div class="pa-3">
    <v-text-field v-model="document.name" hide-details label="Document Name" />
    <v-textarea v-model="document.description" hide-details rows="3" label="Description" />
    <v-text-field v-model="document.note" label="Special Note" hide-details/>
    <div style="display:flex">
        <v-switch color="primary" v-model="document.received" label="Received" hide-details />
        <v-switch color="primary" v-model="form.advanced" label="Show Advanced Details" hide-details/>
    </div>

    <template v-if="form.advanced">
        <div class="section-heading mt-4">Advanced</div> 
        <v-text-field v-model="document.download" label="Download Link" hide-details/>
        <v-switch color="primary" v-model="form.saveAsTemplate" label="Save as Template" hide-details />
        <template v-if="form.saveAsTemplate">
            <v-select v-model="document.lender" :items="lenders" hide-details label="Lender" />
            <v-text-field v-model="document.category" hide-details label="Category" />
            <v-text-field v-model="document.title" hide-details label="Title" />
            <v-text-field v-model="document.option" hide-details label="Option Name" />
            <v-checkbox color="primary" v-model="document.global" label="Global" hide-details />
        </template>
    </template>
</div>
<div slot="footer">
    <DeleteButton  @delete="deleteButtonClicked" style="float:left"></DeleteButton>
</div>
</DialogBox>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import DialogBox from '@/ui-elements/DialogBox'
import StringHelpers from '../../helpers/StringHelpers'
import LookupData from '@/helpers/LookupData'
import FirebaseHelpers from '../../helpers/FirebaseHelpers'
import DeleteButton from '../../ui-elements/DeleteButton'


export default {
    data() {
        return {
            form: {
                saveAsTemplate: false,
                advanced: false,
            }
        
        }
    },

    components: {
        DialogBox, DeleteButton
    },
    
    props: {
        settings: Object,
        document: Object,
    },

    computed: {
        templatePath() {
            return {
            category: StringHelpers.toCamelCase(this.document.category),
            title: StringHelpers.toCamelCase(this.document.title),
            }
        },

        lenders() {
            return ['General',
                ...LookupData.lenders().map(lender => lender.name)
            ]
        },

        tenantKey() {
            return DataHelpers.getTenantKey()
        }
    },

    methods: {
        saveDocument() {
            if(this.form.saveAsTemplate)
                this.saveTemplate()
            this.$emit('save', this.document)
        },

        saveTemplate() {
            let ref = DataHelpers.getRootRef()
            //todo: add some stuff for global
            ref = ref.child('tenants').child(this.tenantKey).child('documentChecklist')
            ref = ref.child(this.document.lender).child(this.templatePath.category).child(this.templatePath.title)
            let newDocument = FirebaseHelpers.cloneWithoutKey(this.document)
            ref.update(newDocument)
        }, 

        deleteButtonClicked() {

        },

        initialise() {
            this.form.saveAsTemplate = false
            this.form.advanced = false
        }
    },

    created() {

    }
}
</script>

<style scoped>
    .section {
        padding:4px 8px;color:white;background-color: #aaa;font-weight:600;
        border-radius:5px;text-transform: uppercase; margin: 10px 0;
    }  
</style>





// WEBPACK FOOTER //
// SupplierDocumentDialog.vue?1884add7